import { BaseGraphqlLayer } from '@core/base';
import { IMutation, IPageContentInput, IPageContentType, IQuery } from '@introspection/index';
import { Injectable } from '@rxdi/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export type PageContent = IPageContentType;

@Injectable()
export class PageService extends BaseGraphqlLayer {
  getPages(): Observable<PageContent[]> {
    return this.query<IQuery>({
      query: 'list-pages.query.graphql',
    }).pipe(map((res) => res.data.listPages));
  }

  getPageById(pageId: string): Observable<PageContent> {
    return this.query<IQuery>({
      query: 'find-page.query.graphql',
      variables: { pageId },
    }).pipe(map((res) => res.data.findPageByPageId));
  }

  createPage(pageInput: IPageContentInput): Observable<PageContent> {
    return this.mutate<IMutation>({
      mutation: 'create-page.mutation.graphql',
      variables: { pageInput },
    }).pipe(map((res) => res.data.createPage));
  }

  updatePage(id: string, pageInput: IPageContentInput): Observable<PageContent> {
    return this.mutate<IMutation>({
      mutation: 'update-page.mutation.graphql',
      variables: { id, pageInput },
    }).pipe(map((res) => res.data.updatePage));
  }

  deletePage(id: string): Observable<PageContent> {
    return this.mutate<IMutation>({
      mutation: 'delete-page.mutation.graphql',
      variables: { id },
    }).pipe(map((res) => res.data.deletePage));
  }
}
